package com.eladfinish.bible.contest.ui.modifiers

import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.ui.Modifier
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.platform.SoftwareKeyboardController

fun Modifier.dismissKeyboardOnTap(
    keyboardController: SoftwareKeyboardController?,
): Modifier = pointerInput(Unit) {
    detectTapGestures(
        onTap = {
            keyboardController?.hide()
        },
    )
}
